import React from "react";
import { GenresTemplate } from "themes/common/components";

function Genres(props) {
    return <GenresTemplate {...props} />;
}

export default Genres;
